import BikeIcon from "../images/bike-icon.svg";
import EasySwapBike from "../images/easy-swap-bike.svg";
import RepairIcon from "../images/repair-icon.svg";
import Available from "../images/available.svg";

const PerksData = [
  {
    id: 1,
    image: BikeIcon,
    imageAlt: "Bike Icon",
    text: "Your own bike",
  },
  {
    id: 2,
    image: RepairIcon,
    imageAlt: "Repair Icon",
    text: "Repairs included",
  },
  {
    id: 3,
    image: Available,
    imageAlt: "Available Icon",
    text: "Available 24*7",
  },
  {
    id: 4,
    image: EasySwapBike,
    imageAlt: "Easy Swap Bike",
    text: "Easy bike swap",
  },
];

export default PerksData;
